// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9wjv8","right":"styles_right__13htP"};